<script lang="ts">
	import { showDebug } from '$lib/client/store';
	import { onDestroy } from 'svelte';
	let ShowDebugInfo: boolean = false;
	export let Config;
	let Shown = false;

	let unsubscribe = showDebug.subscribe((value) => {
		ShowDebugInfo = value;
	});

	onDestroy(() => {
		unsubscribe();
	});
	let ShowDebugPopup = false;
	$: if (Config.Shown) {
		//console.log('FormGroup.svelte Config.Shown:', Config.Shown);
		Shown = Config.Shown;
	}
	$: Shown = Config.Shown;
</script>

{#if ShowDebugInfo}
	<div />
	{#if ShowDebugPopup}
		<span style="font-size: xx-small; position: fixed; top: 30px; left 5px">
			<span style="position: absolute; left: -320px; top: 30px; z-index:1000" class="debug-info">
				<b>Comp ID</b>: {Config.componentId}<br />
				{#each Object.entries(Config) as [key, value]}
					{#if value != null && key != 'componentId' && key != 'id'}
						<b>{key}</b>: {value}<br />
					{/if}
				{/each}
			</span>
		</span>
	{/if}
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		on:mouseover={() => {
			ShowDebugPopup = true;
		}}
		on:mouseout={() => (ShowDebugPopup = false)}
		on:focus={() => (ShowDebugPopup = true)}
		on:blur={() => (ShowDebugPopup = false)}
	>
		<div
			class="form-group row g-2"
			class:required={Config?.Required && Shown}
			class:hidden={!Shown}
		>
			<slot />
		</div>
	</div>
{:else}
	<div class="form-group row g-2" class:required={Config?.Required && Shown} class:hidden={!Shown}>
		<slot />
	</div>
{/if}
